/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint esversion: 9 */
/* jshint esversion: 11 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import { FaStar } from "react-icons/fa";
import {
  IoCallOutline,
  IoCheckmark,
  IoChevronDown,
  IoClose,
} from "react-icons/io5";
import { LuChevronRight, LuPlus, LuTrash2 } from "react-icons/lu";
import AddPatient from "../DocAppointment/AddPatient";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import dayjs from "dayjs";
import { showToast } from "../../showTost";
import { FiMapPin } from "react-icons/fi";
import { TiLocation } from "react-icons/ti";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import Payment from "../../Payment/Payment";
import { MyContext } from "../../Context/MyProvider";
import calendar from "../../assets/Icon/calendar.svg";
import clock from "../../assets/Icon/clock-circle.svg";
import Wallet from "../../assets/Icon/wallet.svg";
import { useTranslation } from "react-i18next";
import Loading from "../Loading";
import secureLocalStorage from "react-secure-storage";
import ImageLoad from "../ImageLoad";
import MapPin from "../../assets/Icon/mappin.svg";

const CartBooking = () => {
  const { t } = useTranslation();

  const today = dayjs();
  const {
    ApiBaseUrl,
    ImgBaseUrl,
    isPayment,
    setIsPayment,
    paymentStatus,
    setPaymentStatus,
    mapKey,
    setActivePage,
    transactionid,
  } = useContext(MyContext);
  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";

  const [labData, setLabData] = useState();
  const [loading, setLoading] = useState(true);
  const [isDriverSelected, setIsDriverSelected] = useState(false);
  const [isDriverSelected2, setIsDriverSelected2] = useState(false);
  const [packageData, setPackageData] = useState([]);
  const [familyData, setFamilyData] = useState([]);
  const [relationshipData, setRelationshipData] = useState([]);
  const [booldData, setBooldData] = useState([]);
  const [isPatient, setIsPatient] = useState(false);
  const [isShowDate, setIsShowDate] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [SelectTime, setSelectTime] = useState("");
  const [openPicker, setOpenPicker] = useState(false);
  const [additionalNote, setAdditionalNote] = useState();
  const [myWallet, setMyWallet] = useState();
  const [myWallet2, setMyWallet2] = useState();
  const [wallet, setWallet] = useState();
  const [isCouponShow, setIsCouponShow] = useState(false);
  const [couponCode, setCouponCode] = useState();
  const [couponList, setCouponList] = useState([]);
  const [taxData, setTaxData] = useState("");
  const [showDeleteBox, setShowDeleteBox] = useState("");
  const [productData, setProductData] = useState([]);
  const [serviceTotal, setServiceTotal] = useState();
  const [TotalAmt, setTotalAmt] = useState();
  const [TotalAmt2, setTotalAmt2] = useState();
  const [commissionData, setCommissionData] = useState();
  const [homeExteraPrice, setHomeExteraPrice] = useState();
  const [isLocationShow, setIsLocationShow] = useState(false);
  const [isLocationShow2, setIsLocationShow2] = useState(false);
  const [addressList, setAddressList] = useState([]);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [value, setValue] = useState();
  const [addressData, setAddressData] = useState({
    address: "",
    houseno: "",
    mobile: "",
    landmark: "",
    instruction: "",
    address_as: "",
  });
  const [selectAddress, setSelectAddress] = useState();
  const [allData, setAllData] = useState();
  const [deletetext, setDeleteText] = useState("");

  const navigate = useNavigate();

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: mapKey,
  });

  const toggleDriverSelection = () => setIsDriverSelected((prev) => !prev);

  const LocalData = sessionStorage.getItem("Docprofile");
  let Categoryid, Labid;
  if (LocalData) {
    ({ Categoryid, Labid } = JSON.parse(LocalData));
  }

  useEffect(() => {
    navigator.geolocation.getCurrentPosition((position) => {
      const lat = position.coords.latitude;
      const long = position.coords.longitude;
      setLatitude(lat);
      setLongitude(long);
    });

    HandleFatchData();
    axios
      .get(`${ApiBaseUrl}/customer/family_member_add_detail`)
      .then((res) => {
        const { relationship_list, blood_group_list } = res.data;
        setRelationshipData(relationship_list);
        setBooldData(blood_group_list);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    loading
      ? (document.body.style.overflow = "hidden")
      : (document.body.style.overflow = "auto");
  }, [loading]);

  const HandleFatchData = () => {
    setLoading(true);
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/package_cart`, {
          id: Userid,
          lab_id: Labid,
          category_id: Categoryid,
        })
        .then((res) => {
          const {
            ResponseCode,
            lab,
            package_detail,
            family_member,
            wallet_amount,
            coupon,
            commission_data,
            home_extra_price,
          } = res.data;
          if (ResponseCode === 200) {
            setLoading(false);
            setHomeExteraPrice(home_extra_price);
            setFamilyData(family_member);
            setLabData(lab);
            setPackageData(package_detail);
            HandleFamilyP(package_detail, family_member);
            setMyWallet(wallet_amount);
            setCouponList(coupon);
            setCommissionData(commission_data);
          }
        })
        .catch((error) => {
          console.error(error);
        });

      axios
        .post(`${ApiBaseUrl}/customer/address_list`, { id: Userid })
        .then((res) => {
          setAddressList(res.data.address_list);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleFamilyP = (item, family_member) => {
    const AllData = [];
    for (let i = 0; i < item.length; i++) {
      const hasFamily =
        Array.isArray(family_member) && family_member.length > 0;
      AllData.push({
        pid: item[i].id,
        f: hasFamily ? [family_member[0].id] : "",
        total: hasFamily ? item[i].package_price : 0,
      });
    }
    setProductData(AllData);
  };

  useEffect(() => {
    const Total = productData.reduce((sum, item) => sum + item.total, 0);
    setServiceTotal(Total);
  }, [productData]);

  useEffect(() => {
    const total = Number(taxData.Rate) + serviceTotal;
    setTotalAmt2(isDriverSelected2 ? total + homeExteraPrice : total);
    const TotalAmount = couponCode ? total - couponCode.amt : total;
    setTotalAmt(TotalAmount);
  }, [taxData, serviceTotal, couponCode]);

  useEffect(() => {
    const Total = isDriverSelected2 ? TotalAmt + homeExteraPrice : TotalAmt2;
    setTotalAmt(Total);
  }, [isDriverSelected2]);

  useEffect(() => {
    if (myWallet > TotalAmt) {
      const CouponTotal = couponCode ? TotalAmt2 - couponCode.amt : TotalAmt2;
      setTotalAmt(isDriverSelected ? 0 : CouponTotal);
      setWallet(isDriverSelected ? CouponTotal : 0);
    } else {
      const Total = isDriverSelected ? TotalAmt - myWallet : TotalAmt2;
      setTotalAmt(Total);
    }

    if (myWallet < TotalAmt) {
      setMyWallet2(isDriverSelected ? 0 : myWallet);
      setWallet(isDriverSelected ? myWallet : 0);
    } else {
      const MyTotal = isDriverSelected ? myWallet - TotalAmt : myWallet;
      setMyWallet2(MyTotal);
    }
  }, [isDriverSelected]);

  const HandleBook = (id) => {
    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      axios
        .post(`${ApiBaseUrl}/customer/add_cart`, {
          id: Userid,
          lab_id: Labid,
          package_id: id,
        })
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            HandleFatchData();
            setShowDeleteBox("");
            if (packageData.length === 1) {
              navigate("/packages");
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    if (!commissionData) return;

    if (commissionData.commission_type === "fix") {
      setTaxData({
        Rate: commissionData.commission,
        type: commissionData.commission_type,
      });
    } else {
      const TaxRate = serviceTotal / commissionData.commission;
      const TaxType =
        commissionData.commission + commissionData.commission_type;
      setTaxData({ Rate: TaxRate, type: TaxType });
    }
  }, [commissionData, serviceTotal]);

  const SelectPatientHandle = (patientid, price, id) => {
    if (isDriverSelected) {
      setIsDriverSelected(false);
    }

    const updatedData = productData.map((product) => {
      if (product.pid === id) {
        const isAlreadySelected = product.f.includes(patientid);
        const updatedF = isAlreadySelected
          ? product.f.filter((p) => p !== patientid)
          : [...product.f, patientid];
        const unitPrice = product.total || 0;
        const total = isAlreadySelected ? unitPrice - price : unitPrice + price;

        return { ...product, f: updatedF, total };
      }
      return product;
    });

    setProductData(updatedData);
  };

  const disablePastDates = (date) => {
    return date.isBefore(today, "day");
  };

  const handleStartTimeChange = (newValue) => {
    setSelectTime(newValue.format("hh:mm A"));
  };

  const HandleCoupanAdd = (code, amt, id) => {
    setCouponCode({ code, amt, id });
    showToast({ title: t("Coupon Add Successful"), id: "success" });
    setIsCouponShow(false);
  };

  const HandleProceed = async () => {
    const hasMissingPatients = productData.some((item) => item.f.length < 1);

    if (hasMissingPatients) {
      showToast({ title: t("Please Select Patients"), id: "error" });
      return;
    }

    if (!selectDate || !SelectTime) {
      showToast({ title: t("Please Select Date & Time"), id: "error" });
      return;
    }

    if (isDriverSelected2 && !selectAddress) {
      showToast({ title: t("Please Select Address"), id: "error" });
      return;
    }

    if (isDriverSelected && TotalAmt === 0) {
      HandleBooking();
    } else {
      setIsPayment(true);

      const Userid = secureLocalStorage.getItem("Userid");
      const TotalPrice = couponCode ? TotalAmt2 - couponCode.amt : TotalAmt2;

      const Data = {
        id: Userid,
        lab_id: Labid,
        category_id: Categoryid,
        date: selectDate.format("DD-MM-YYYY"),
        time: SelectTime,
        message: additionalNote ? additionalNote : "",
        address: isDriverSelected2 ? selectAddress.id : "",
        package_list: await HandlePackageListGet(),
        family_mem_id: await HandleGetMemberIds(),
        tot_package_price: await HandleGetPackagePrice(productData),
        tot_price: TotalPrice,
        home_extra_price: isDriverSelected2 ? homeExteraPrice : 0,
        coupon_id: couponCode ? couponCode.id : "",
        coupon_amount: couponCode ? couponCode.amt : 0,
        site_commission: taxData.Rate,
        wallet_amount: isDriverSelected ? wallet : 0,
        home_col_status: isDriverSelected2 ? 1 : 0,
      };

      setAllData(Data);
      sessionStorage.setItem("page", "2");
    }
  };

  const HandleCoupanRemove = () => {
    if (couponCode) {
      setCouponCode("");
    } else {
      setIsCouponShow(true);
    }
    if (isDriverSelected) {
      setIsDriverSelected(!isDriverSelected);
    }
  };

  const HandlePackageListGet = async () => {
    return productData.map(({ pid, f }) => ({ pid, f }));
  };

  const HandleGetMemberIds = () => {
    const memberIds = [...new Set(productData.flatMap((item) => item.f))];
    return memberIds;
  };

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();
    setLatitude(lat);
    setLongitude(lng);
  };

  const HandleGetGoogleAddress = async (lat, lng) => {
    try {
      const response = await axios.get(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${mapKey}`,
      );
      const address = response.data.results[0]?.formatted_address;
      return address;
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const HandleSaveAddress = async () => {
    HandleGetGoogleAddress(latitude, longitude);

    if (
      !addressData.address &&
      !addressData.houseno &&
      !addressData.landmark &&
      !addressData.instruction &&
      !addressData.address_as
    ) {
      showToast({ title: t("Please Enter Details"), id: "error" });
      return;
    }

    if (!value) {
      showToast({ title: t("Please Enter Details"), id: "error" });
      return;
    }

    const Userid = secureLocalStorage.getItem("Userid");
    if (Userid) {
      const formattedNumber = formatPhoneNumberIntl(value);
      const countryCode = formattedNumber.split(" ")[0];
      const numberWithoutCode = formattedNumber.replace(countryCode, "").trim();
      const cleanedNumber = numberWithoutCode.split(" ").join("");

      const Data = {
        id: Userid,
        house_no: addressData.houseno,
        address: addressData.address,
        landmark: addressData.landmark,
        address_as: addressData.address_as,
        country_code: countryCode,
        phone: cleanedNumber,
        latitude: latitude,
        longitude: longitude,
        google_address: await HandleGetGoogleAddress(latitude, longitude),
        instruction: addressData.instruction,
      };

      axios
        .post(`${ApiBaseUrl}/customer/add_address`, Data)
        .then((res) => {
          if (res.data.ResponseCode === 200) {
            setIsLocationShow2("");
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    if (!paymentStatus) return;
    if (paymentStatus === "PaymentDone") {
      HandleBooking();
      setPaymentStatus("");
      setIsPayment(false);
    }
  }, [paymentStatus]);

  const HandleBooking = async () => {
    const Userid = secureLocalStorage.getItem("Userid");
    const PaymentId = sessionStorage.getItem("Paymentid");
    const TotalPrice = couponCode ? TotalAmt2 - couponCode.amt : TotalAmt2;

    if (Userid) {
      const Data = {
        id: Userid,
        lab_id: Labid,
        category_id: Categoryid,
        date: selectDate.format("DD-MM-YYYY"),
        time: SelectTime,
        message: additionalNote ? additionalNote : "",
        address: isDriverSelected2 ? selectAddress.id : "",
        package_list: await HandlePackageListGet(),
        family_mem_id: await HandleGetMemberIds(),
        tot_package_price: await HandleGetPackagePrice(productData),
        tot_price: TotalPrice,
        home_extra_price: isDriverSelected2 ? homeExteraPrice : 0,
        coupon_id: couponCode ? couponCode.id : "",
        coupon_amount: couponCode ? couponCode.amt : 0,
        site_commission: taxData.Rate,
        payment_id: PaymentId ? PaymentId : "",
        wallet_amount: isDriverSelected ? wallet : 0,
        home_col_status: isDriverSelected2 ? 1 : 0,
        transactionId: sessionStorage.getItem("transactionId") || transactionid || "",
      };

      axios
        .post(`${ApiBaseUrl}/customer/add_lab_book`, Data)
        .then((res) => {
          const { message, ResponseCode } = res.data;
          if (ResponseCode === 200) {
            setIsPayment(false);
            showToast({ title: message, id: "success" });
            navigate("/booking-package");
            setActivePage(3);
            sessionStorage.removeItem("transactionId");
          } else {
            showToast({ title: message || t("Booking Failed"), id: "error" });
          }
        })
        .catch((error) => {
          console.error(error);
          showToast({ title: error?.response?.data?.message || t("Booking Request Failed"), id: "error" });
        });
    }
  };

  const HandleGetPackagePrice = (data) => {
    const totalSum = data.reduce((sum, item) => sum + item.total, 0);
    return totalSum;
  };

  return (
    <div className="w-full width-container pb-[80px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto packages-checkout-container">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation Section */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <Link
              to="/"
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoIosArrowBack className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Home")}</span>
            </Link>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Link
                to="/packages"
                className="hover:text-indigo-600 font-medium transition-colors"
              >
                {t("Packages")}
              </Link>
              <IoIosArrowForward className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">
                {t("Cart Booking")}
              </span>
            </div>
          </div>

          {/* Responsive Grid Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
            {/* Left Side Columns (Occupies 2cols on Desktop) */}
            <div className="lg:col-span-2 space-y-6">
              {/* Lab Details Section */}
              <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm">
                <h2 className="font-bold text-slate-800 text-lg mb-4">
                  {t("Lab Details")}
                </h2>
                <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                  <div className="relative group overflow-hidden rounded-2xl border border-slate-200/60 bg-white p-1 shrink-0">
                    <ImageLoad
                      src={ImgBaseUrl + labData?.logo}
                      CustomeStyle="w-20 h-20 object-cover rounded-xl"
                      alt={labData?.name}
                    />
                  </div>
                  <div className="leading-snug">
                    <h3 className="font-semibold text-slate-800 text-lg">
                      {labData?.name}
                    </h3>
                    <p className="text-slate-500 text-sm mt-1 mb-2">
                      {labData?.address}
                    </p>
                    <div className="flex items-center gap-1 bg-amber-50 text-amber-700 px-2.5 py-1 rounded-full shrink-0 border border-amber-100 w-fit text-xs font-semibold">
                      <FaStar className="w-3.5 h-3.5 text-amber-500 fill-amber-500" />
                      <span>{labData?.avg_star}</span>
                      <span className="text-slate-400 font-medium">
                        ({labData?.tot_review}+ {t("Rating")})
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Cart Items / Package Details */}
              <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm">
                <h2 className="font-bold text-slate-800 text-lg mb-4">
                  {t("Test Details & Package Details")}
                </h2>
                <div className="space-y-4">
                  {packageData?.map((item, Index) => {
                    const PatientLength = productData[Index]?.f || [];
                    return (
                      <div
                        key={Index}
                        className="border border-slate-100 rounded-2xl p-4 md:p-5 hover:shadow-sm transition-all duration-200"
                      >
                        <div className="flex items-start justify-between gap-4">
                          <div className="flex items-start gap-4 flex-1">
                            <div className="relative group overflow-hidden rounded-2xl border border-slate-200/60 bg-white p-1 shrink-0">
                              <ImageLoad
                                src={ImgBaseUrl + item.logo}
                                CustomeStyle="h-[60px] w-[60px] object-contain rounded-xl"
                                alt={item.title}
                              />
                            </div>
                            <div className="flex-1 min-w-0">
                              <h3 className="font-semibold text-slate-800 text-base md:text-lg truncate">
                                {item.title}
                              </h3>
                              <p className="text-slate-500 text-sm mt-0.5 line-clamp-1">
                                {item.subtitle}
                              </p>
                              <span className="inline-block text-indigo-600 bg-indigo-50 border border-indigo-100 rounded-full px-2.5 py-0.5 text-xs font-semibold mt-2">
                                {t("Includes")} {item.package_name} {t("tests")}
                              </span>
                              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mt-4 pt-3 border-t border-slate-50">
                                <span className="font-semibold text-slate-800 text-sm md:text-base">
                                  {t("Package Price")}:{" "}
                                  <span className="text-indigo-600">
                                    {currency}
                                    {item.package_price}
                                  </span>{" "}
                                  x{" "}
                                  <span className="text-slate-500">
                                    {PatientLength.length}
                                  </span>
                                </span>
                                <span className="font-semibold text-slate-900 text-base md:text-lg">
                                  {currency}
                                  {productData[Index]?.total}.00
                                </span>
                              </div>
                            </div>
                          </div>

                          <button
                            onClick={() => {
                              setShowDeleteBox(item.id);
                              setDeleteText(item.title);
                            }}
                            className="p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-all duration-200 shrink-0"
                            aria-label="Remove item"
                          >
                            <LuTrash2 className="w-5 h-5" />
                          </button>
                        </div>

                        {/* Patient Selection list */}
                        <div className="mt-5 pt-4 border-t border-slate-100">
                          <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block mb-3">
                            {t("Select Patients for this test")}
                          </span>
                          <div className="patient-list overflow-visible">
                            <Swiper
                              slidesPerView={"auto"}
                              spaceBetween={16}
                              modules={[Pagination]}
                              className="mySwiper !overflow-visible"
                            >
                              {/* Add Patient Button */}
                              <SwiperSlide
                                onClick={() => setIsPatient(true)}
                                className="!w-auto flex flex-col items-center cursor-pointer select-none"
                              >
                                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-dashed border-slate-200 hover:border-indigo-500 text-slate-400 hover:text-indigo-600 flex items-center justify-center transition-all duration-200 bg-slate-50">
                                  <LuPlus className="w-6 h-6" />
                                </div>
                                <span className="text-slate-500 text-xs text-center font-medium mt-2">
                                  {t("Add New")}
                                </span>
                              </SwiperSlide>

                              {/* Family Members List */}
                              {familyData?.map((item2, index) => {
                                const isSelected = productData[
                                  Index
                                ]?.f.includes(item2.id);
                                return (
                                  <SwiperSlide
                                    key={index}
                                    onClick={() =>
                                      SelectPatientHandle(
                                        item2.id,
                                        item.package_price,
                                        item.id,
                                      )
                                    }
                                    className="!w-auto cursor-pointer"
                                  >
                                    <div className="relative flex flex-col items-center justify-center text-center">
                                      <div className="relative">
                                        <ImageLoad
                                          src={ImgBaseUrl + item2.profile_image}
                                          CustomeStyle={`w-16 h-16 md:w-20 md:h-20 object-cover rounded-full transition-transform duration-300 hover:scale-105 shadow-sm ${isSelected ? "ring-4 ring-indigo-600 ring-offset-2" : "border border-slate-200 bg-white"}`}
                                          alt={item2.name}
                                        />
                                        {isSelected && (
                                          <div className="absolute -top-1 -right-1 bg-indigo-600 text-white rounded-full p-1 shadow border border-white flex items-center justify-center">
                                            <IoCheckmark className="w-3.5 h-3.5" />
                                          </div>
                                        )}
                                      </div>
                                      <h3 className="font-semibold text-slate-700 text-xs md:text-sm mt-2 max-w-[80px] truncate">
                                        {item2.name}
                                      </h3>
                                    </div>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Right Side Column (Occupies 1col on Desktop) */}
            <div className="lg:col-span-1 space-y-6">
              {/* Collection Time Slot Card */}
              <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm">
                <h2 className="font-bold text-slate-800 text-lg mb-4">
                  {t("Select Sample Collection Slot")}
                </h2>
                <div className="grid grid-cols-2 gap-4">
                  <button
                    onClick={() => setIsShowDate(true)}
                    className="flex flex-col items-center justify-center p-4 border border-slate-200 rounded-2xl hover:border-indigo-500 hover:bg-indigo-50/20 active:scale-98 transition-all duration-200 gap-2 font-semibold text-sm"
                  >
                    <img
                      src={calendar}
                      className="w-6 h-6 opacity-85"
                      alt="calendar"
                    />
                    <span
                      className={
                        selectDate
                          ? "text-indigo-600 font-bold text-[13px]"
                          : "text-slate-600 text-[13px]"
                      }
                    >
                      {selectDate
                        ? selectDate.format("DD-MM-YYYY")
                        : t("Select Date")}
                    </span>
                  </button>
                  <button
                    onClick={() => setOpenPicker(true)}
                    className="flex flex-col items-center justify-center p-4 border border-slate-200 rounded-2xl hover:border-indigo-500 hover:bg-indigo-50/20 active:scale-98 transition-all duration-200 gap-2 font-semibold text-sm"
                  >
                    <img
                      src={clock}
                      className="w-6 h-6 opacity-85"
                      alt="clock"
                    />
                    <span
                      className={
                        SelectTime
                          ? "text-indigo-600 font-bold text-[13px]"
                          : "text-slate-600 text-[13px]"
                      }
                    >
                      {SelectTime ? SelectTime : t("Select Time")}
                    </span>
                  </button>
                </div>
                <div className="hidden">
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileTimePicker
                      label="Pick-Up Time"
                      value={
                        SelectTime ? dayjs(SelectTime, "hh:mm A") : dayjs()
                      }
                      onChange={handleStartTimeChange}
                      ampm
                      open={openPicker}
                      onClose={() => setOpenPicker(false)}
                    />
                  </LocalizationProvider>
                </div>
              </div>

              {/* Additional Message Note */}
              <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm">
                <h2 className="font-bold text-slate-800 text-lg mb-3">
                  {t("Symptoms / Private Note")}
                </h2>
                <textarea
                  maxLength={500}
                  onChange={(e) => setAdditionalNote(e.target.value)}
                  className="w-full min-h-[100px] border border-slate-200 rounded-2xl p-4 text-sm text-slate-700 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 resize-none transition-all"
                  placeholder={t("Message")}
                />
              </div>

              {/* Wallet toggle config */}
              {Number(myWallet) > 0 && (
                <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="font-bold text-slate-800 text-lg">
                      {t("Pay from Wallet")}
                    </h2>
                    <label className="relative inline-flex items-center cursor-pointer select-none">
                      <input
                        type="checkbox"
                        checked={isDriverSelected}
                        onChange={toggleDriverSelection}
                        className="sr-only peer"
                      />
                      <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                    </label>
                  </div>
                  <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <img
                        src={Wallet}
                        className="w-6 h-6 opacity-85"
                        alt="wallet"
                      />
                      <span className="font-medium text-slate-700 text-sm md:text-base">
                        {t("My Wallet")}
                      </span>
                    </div>
                    <span className="font-bold text-indigo-600 text-lg">
                      {currency}
                      {isDriverSelected
                        ? Number(myWallet2).toFixed(0)
                        : Number(myWallet).toFixed(0)}
                      .00
                    </span>
                  </div>
                </div>
              )}

              {/* Coupon Selection Card */}
              {couponList.length > 0 && (
                <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm">
                  <div className="flex items-start justify-between pb-4 border-b border-slate-100 mb-3 gap-2">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          stroke="none"
                        >
                          <path d="M12.01 2.011c.852 0 1.668 .34 2.267 .942l.698 .698a1.2 1.2 0 0 0 .845 .349h1a3.2 3.2 0 0 1 3.2 3.2v1c0 .316 .126 .62 .347 .843l.698 .698a3.2 3.2 0 0 1 .002 4.536l-.698 .698a1.2 1.2 0 0 0 -.349 .845v1a3.2 3.2 0 0 1 -3.2 3.2h-1a1.2 1.2 0 0 0 -.843 .347l-.698 .698a3.2 3.2 0 0 1 -4.536 .002l-.698 -.698a1.2 1.2 0 0 0 -.845 -.349h-1a3.2 3.2 0 0 1 -3.2 -3.2v-1a1.2 1.2 0 0 0 -.347 -.843l-.698 -.698a3.2 3.2 0 0 1 -.002 -4.536l.698 -.698a1.2 1.2 0 0 0 .349 -.845v-1l.005 -.182a3.2 3.2 0 0 1 3.195 -3.018h1a1.2 1.2 0 0 0 .843 -.347l.698 -.698a3.2 3.2 0 0 1 2.269 -.944m2.49 10.989a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3m1.207 -4.707a1 1 0 0 0 -1.414 0l-6 6a1 1 0 0 0 1.414 1.414l6 -6a1 1 0 0 0 0 -1.414m-6.207 -.293a1.5 1.5 0 1 0 0 3a1.5 1.5 0 0 0 0 -3"></path>
                        </svg>
                      </div>
                      <div className="leading-snug">
                        <h3 className="font-bold text-indigo-600 text-base">
                          {t("Apply Coupon")}
                        </h3>
                        {couponCode && (
                          <span className="text-slate-500 text-xs mt-0.5 block">
                            {t("Use Code")}:{" "}
                            <span className="font-bold text-slate-800">
                              {couponCode.code}
                            </span>
                          </span>
                        )}
                      </div>
                    </div>
                    <button
                      onClick={HandleCoupanRemove}
                      className={`px-4 py-1.5 rounded-full text-xs font-bold border transition-all active:scale-95 ${couponCode ? "bg-rose-50 border-rose-200 text-rose-600 hover:bg-rose-100" : "bg-indigo-50 border-indigo-200 text-indigo-600 hover:bg-indigo-100"}`}
                    >
                      {couponCode ? t("Remove") : t("Apply")}
                    </button>
                  </div>
                  <div
                    onClick={() => !couponCode && setIsCouponShow(true)}
                    className="flex items-center justify-between py-2 cursor-pointer hover:bg-slate-50 px-2 rounded-xl transition-colors duration-150"
                  >
                    <span className="text-slate-500 text-sm font-medium">
                      {t("View All Coupons")}
                    </span>
                    <LuChevronRight className="text-slate-400 text-lg" />
                  </div>
                </div>
              )}

              {/* Home Collection Configuration */}
              {homeExteraPrice !== "0" && (
                <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm space-y-4">
                  <div>
                    <div className="flex items-center justify-between mb-1">
                      <h3 className="font-bold text-slate-800 text-base">
                        {t("Home Service")}
                      </h3>
                      <label className="relative inline-flex items-center cursor-pointer select-none">
                        <input
                          type="checkbox"
                          checked={isDriverSelected2}
                          onChange={() =>
                            setIsDriverSelected2(!isDriverSelected2)
                          }
                          className="sr-only peer"
                        />
                        <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600"></div>
                      </label>
                    </div>
                    <span className="text-slate-500 text-xs block">
                      {t("Collect sample at my doorstep")}
                    </span>
                    <span className="text-indigo-600 font-bold text-xs block mt-1">
                      {t("Additional Cost")}: {currency}
                      {homeExteraPrice}
                    </span>
                  </div>

                  {/* Address Display Details block */}
                  <div className="bg-slate-50 border border-slate-100 rounded-2xl p-4">
                    {isDriverSelected2 ? (
                      <div className="flex items-center justify-between gap-3">
                        <div className="flex-1 min-w-0">
                          <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                            {t("Home Address")}
                          </span>
                          <span className="font-bold text-slate-800 text-sm truncate block mt-0.5">
                            {selectAddress
                              ? selectAddress.address
                              : t("Choose Location")}
                          </span>
                        </div>
                        <button
                          onClick={() => setIsLocationShow(true)}
                          className="p-2 border border-slate-200 rounded-xl bg-white hover:bg-slate-50 text-indigo-600 flex items-center justify-center shrink-0"
                          aria-label="Choose Address"
                        >
                          <FiMapPin className="w-4 h-4" />
                          <IoChevronDown className="w-3 h-3 ml-1" />
                        </button>
                      </div>
                    ) : (
                      <div className="space-y-2">
                        <div>
                          <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                            {t("Appointment Location")}
                          </span>
                          <p className="text-slate-600 text-sm leading-relaxed mt-0.5">
                            {t("Visit the lab address directly:")}
                          </p>
                        </div>
                        <div className="flex items-start gap-2 pt-2 border-t border-slate-200/60 text-slate-800 text-sm font-semibold">
                          <FiMapPin className="w-4 h-4 text-indigo-600 shrink-0 mt-0.5" />
                          <span>{labData?.address}</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Summary Invoice Details */}
              <div className="bg-white rounded-3xl border border-slate-150 p-5 shadow-sm space-y-3.5">
                <h2 className="font-bold text-slate-800 text-lg border-b border-slate-100 pb-3">
                  {t("Bill Review Summary")}
                </h2>

                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-500 font-medium">
                    {t("Service Total")}
                  </span>
                  <span className="text-slate-800 font-semibold">
                    {currency}
                    {serviceTotal}.00
                  </span>
                </div>

                {isDriverSelected && (
                  <div className="flex items-center justify-between text-sm text-green-600">
                    <span className="font-medium">{t("Pay from Wallet")}</span>
                    <span className="font-semibold">
                      -{currency}
                      {wallet}.00
                    </span>
                  </div>
                )}

                {couponCode && (
                  <div className="flex items-center justify-between text-sm text-green-600">
                    <span className="font-medium">{t("Coupon Discount")}</span>
                    <span className="font-semibold">
                      -{currency}
                      {couponCode.amt}
                    </span>
                  </div>
                )}

                {isDriverSelected2 && (
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-slate-500 font-medium">
                      {t("Home Collection Fee")}
                    </span>
                    <span className="text-slate-800 font-semibold">
                      +{currency}
                      {homeExteraPrice}.00
                    </span>
                  </div>
                )}

                <div className="flex items-center justify-between text-sm">
                  <span className="text-slate-500 font-medium">
                    {t("Service Fee & Tax")} ({taxData?.type})
                  </span>
                  <span className="text-slate-800 font-semibold">
                    +{currency}
                    {taxData?.Rate}.0
                  </span>
                </div>

                <div className="flex items-center justify-between pt-4 border-t border-dashed border-slate-200 mt-2">
                  <span className="text-slate-800 font-bold text-base">
                    {t("Total Payable Amount")}
                  </span>
                  <span className="text-indigo-600 font-bold text-lg">
                    {currency}
                    {TotalAmt}.00
                  </span>
                </div>
              </div>

              {/* Floating Checkout box */}
              <div className="bg-slate-900 text-white rounded-3xl p-5 flex items-center justify-between gap-6">
                <div>
                  <span className="text-slate-400 text-xs font-semibold uppercase tracking-wider block">
                    {t("Total Payable")}
                  </span>
                  <span className="font-extrabold text-xl block mt-0.5">
                    {currency}
                    {TotalAmt}.00
                  </span>
                </div>
                <button
                  onClick={HandleProceed}
                  className="bg-indigo-600 hover:bg-indigo-700 text-white font-semibold text-sm px-6 py-3.5 rounded-2xl transition-all duration-200 active:scale-95 inline-flex items-center justify-center shrink-0 min-w-[140px]"
                >
                  {t("Proceed")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Premium Dialog Modals */}

      {/* Add Patient Modal */}
      {isPatient && (
        <div
          onClick={() => setIsPatient(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl shadow-2xl max-w-xl w-full max-h-[85vh] overflow-y-auto scroll-container p-6 relative"
          >
            <button
              onClick={() => setIsPatient(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close"
            >
              <IoClose className="w-6 h-6" />
            </button>
            <div className="mt-2">
              <AddPatient Relation={relationshipData} BooldType={booldData} />
            </div>
          </div>
        </div>
      )}

      {/* Date Calendar Modal */}
      {isShowDate && (
        <div
          onClick={() => setIsShowDate(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl shadow-2xl p-5 relative overflow-hidden max-w-sm w-full"
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateCalendar
                value={selectDate ? selectDate : today}
                shouldDisableDate={disablePastDates}
                onChange={(newDate) => {
                  setSelectDate(newDate);
                  setIsShowDate(false);
                }}
              />
            </LocalizationProvider>
            <div className="flex items-center justify-end gap-4 px-4 text-indigo-600 font-bold pt-3 border-t border-slate-100 mt-2 text-sm font-semibold">
              <button
                onClick={() => setIsShowDate(false)}
                className="hover:text-indigo-800 transition-colors uppercase"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={() => {
                  setIsShowDate(false);
                  !selectDate && setSelectDate(today);
                }}
                className="hover:text-indigo-800 transition-colors uppercase"
              >
                {t("Ok")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Coupon List Dialog */}
      {isCouponShow && (
        <div
          onClick={() => setIsCouponShow(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-lg w-full max-h-[80vh] flex flex-col p-6 relative overflow-hidden"
          >
            <button
              onClick={() => setIsCouponShow(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <h2 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Best Coupon Available")}
              </h2>
              <p className="text-slate-500 text-xs mt-0.5">
                {t("Apply coupons to save more on diagnostic services")}
              </p>
            </div>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 space-y-3.5 max-h-[420px]">
              {couponList.map((item, index) => {
                const isEligible = TotalAmt >= item.min_amount;
                return (
                  <div
                    key={index}
                    className="bg-slate-50 hover:bg-slate-100/60 border border-slate-100 rounded-2xl p-4 transition-all duration-200 flex items-center justify-between gap-4 relative overflow-hidden"
                  >
                    <div className="flex-1 min-w-0">
                      <h3 className="font-bold text-slate-800 text-base md:text-lg">
                        {item.title}
                      </h3>
                      <p className="text-slate-500 text-xs mt-0.5">
                        {item.sub_title}
                      </p>

                      <div className="grid grid-cols-2 gap-x-4 gap-y-1 mt-3 text-xs text-slate-600">
                        <span>
                          {t("Coupon Code")}:{" "}
                          <span className="font-bold text-indigo-600">
                            {item.code}
                          </span>
                        </span>
                        <span>
                          {t("Discount")}:{" "}
                          <span className="font-bold text-slate-800">
                            {currency}
                            {item.discount_amount}
                          </span>
                        </span>
                        <span>
                          {t("Min Order")}:{" "}
                          <span className="font-bold text-slate-800">
                            {currency}
                            {item.min_amount}
                          </span>
                        </span>
                        <span>
                          {t("Expires")}:{" "}
                          <span className="font-bold text-slate-800">
                            {item.end_date}
                          </span>
                        </span>
                      </div>

                      <button
                        disabled={!isEligible}
                        onClick={() =>
                          HandleCoupanAdd(
                            item.code,
                            item.discount_amount,
                            item.id,
                          )
                        }
                        className={`mt-4 font-bold text-xs px-4 py-2 rounded-full shadow-sm active:scale-95 transition-all duration-150 ${isEligible ? "bg-indigo-600 hover:bg-indigo-700 text-white cursor-pointer" : "bg-slate-200 text-slate-400 cursor-not-allowed"}`}
                      >
                        {t("Apply Coupon")}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteBox && (
        <div
          onClick={() => setShowDeleteBox("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-sm w-full text-center"
          >
            <div className="w-12 h-12 rounded-full bg-rose-50 text-rose-600 flex items-center justify-center mx-auto mb-4 border border-rose-100">
              <LuTrash2 className="w-6 h-6" />
            </div>
            <h2 className="font-bold text-slate-800 text-lg">
              {t("Remove Package?")}
            </h2>
            <p className="text-slate-500 text-sm leading-relaxed mt-2">
              {t("Are you sure you want to delete all items of")}{" "}
              <strong className="text-slate-800">{deletetext}</strong>{" "}
              {t("from your cart?")}
            </p>
            <div className="flex items-center gap-3 justify-center mt-5">
              <button
                onClick={() => setShowDeleteBox("")}
                className="flex-1 py-2.5 px-4 border border-slate-200 hover:border-slate-300 text-slate-500 font-semibold rounded-xl text-sm transition-all duration-155 active:scale-98"
              >
                {t("Cancel")}
              </button>
              <button
                onClick={() => HandleBook(showDeleteBox)}
                className="flex-1 py-2.5 px-4 bg-rose-600 hover:bg-rose-700 text-white font-semibold rounded-xl text-sm shadow-sm transition-all duration-155 active:scale-98"
              >
                {t("Remove")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Address Picker Modal */}
      {isLocationShow && (
        <div
          onClick={() => setIsLocationShow("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-lg w-full max-h-[80vh] flex flex-col p-6 relative overflow-hidden"
          >
            <button
              onClick={() => setIsLocationShow("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <h2 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Choose a Delivery Address")}
              </h2>
              <p className="text-slate-500 text-xs mt-0.5">
                {t("Select an address for sample collection")}
              </p>
            </div>

            <button
              onClick={() => {
                setIsLocationShow2(true);
                setIsLocationShow("");
              }}
              className="flex items-center gap-3 mb-4 w-full p-4 border border-dashed border-indigo-200 hover:border-indigo-500 bg-indigo-50/20 hover:bg-indigo-50/45 rounded-2xl transition-all duration-200 active:scale-99"
            >
              <span className="w-10 h-10 rounded-full bg-white border border-indigo-150 flex items-center justify-center text-indigo-600 shrink-0">
                <LuPlus className="w-5 h-5" />
              </span>
              <span className="font-bold text-indigo-600 text-base">
                {t("Add New Address")}
              </span>
            </button>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 space-y-3.5 max-h-[350px]">
              {addressList.length >= 1 ? (
                addressList.map((item, index) => {
                  return (
                    <div
                      onClick={() => {
                        setSelectAddress({
                          address: item.address,
                          id: item.id,
                        });
                        setIsLocationShow("");
                      }}
                      key={index}
                      className="border border-slate-150 hover:border-indigo-500/20 bg-white hover:bg-slate-50 rounded-2xl p-4 cursor-pointer transition-all duration-200 flex flex-col justify-between gap-2 shadow-sm"
                    >
                      <h3 className="font-bold text-slate-800 text-base">
                        {item.address_as} {t("Address")}
                      </h3>
                      <div className="flex items-center gap-2 text-slate-500 text-sm">
                        <IoCallOutline className="text-green-500 w-5 h-5 shrink-0" />
                        <span className="font-medium">
                          {item.country_code} {item.phone}
                        </span>
                      </div>
                      <div className="flex items-start gap-2 text-slate-700 text-sm">
                        <TiLocation className="text-indigo-600 w-5 h-5 shrink-0 mt-0.5" />
                        <span className="font-semibold">{item.address}</span>
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="h-[200px] flex flex-col items-center justify-center text-slate-400 gap-2">
                  <TiLocation className="w-12 h-12 opacity-60" />
                  <h3 className="font-bold text-slate-500">
                    {t("No Address Found")}
                  </h3>
                  <p className="text-slate-400 text-xs">
                    {t("Add an address to start home service collections.")}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Google Map Address Add Form Modal */}
      {isLocationShow2 && (
        <div
          onClick={() => setIsLocationShow2("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-[24px] shadow-2xl max-w-xl w-full max-h-[85vh] flex flex-col p-6 relative overflow-hidden mx-4"
          >
            <button
              onClick={() => setIsLocationShow2("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close"
            >
              <IoClose className="w-5 h-5" />
            </button>

            <div className="mb-4 pr-8">
              <h2 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Add New Address")}
              </h2>
              <p className="text-slate-500 text-xs mt-0.5">
                {t("Confirm your collection address pin on the map")}
              </p>
            </div>

            <div className="flex-1 overflow-y-auto scroll-container pr-1 py-1 space-y-4 max-h-[460px]">
              <div className="h-[180px] rounded-2xl overflow-hidden border border-slate-200 relative bg-slate-100">
                {isLoaded && (
                  <GoogleMap
                    mapContainerStyle={{ width: "100%", height: "100%" }}
                    center={{ lat: latitude, lng: longitude }}
                    zoom={15}
                    onClick={handleMapClick}
                  >
                    <Marker
                      icon={{
                        url: MapPin,
                        scaledSize: new window.google.maps.Size(25, 25),
                      }}
                      position={{ lat: latitude, lng: longitude }}
                    />
                  </GoogleMap>
                )}
              </div>

              <div className="space-y-3">
                <div>
                  <label className="text-slate-600 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                    {t("Complete Address")}
                  </label>
                  <textarea
                    onChange={(e) =>
                      setAddressData({
                        ...addressData,
                        address: e.target.value,
                      })
                    }
                    className="w-full min-h-[70px] border border-slate-200 rounded-xl p-3 text-sm text-slate-700 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 resize-none transition-all"
                    placeholder={t(
                      "Complete street name, flat/building address...",
                    )}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="text-slate-600 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                      {t("House / Flat No")}
                    </label>
                    <input
                      onChange={(e) =>
                        setAddressData({
                          ...addressData,
                          houseno: e.target.value,
                        })
                      }
                      className="w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-700 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-all"
                      type="text"
                      placeholder={t("House no")}
                    />
                  </div>
                  <div>
                    <label className="text-slate-600 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                      {t("Landmark")}
                    </label>
                    <input
                      onChange={(e) =>
                        setAddressData({
                          ...addressData,
                          landmark: e.target.value,
                        })
                      }
                      className="w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-700 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-all"
                      type="text"
                      placeholder={t("Landmark")}
                    />
                  </div>
                </div>

                <div>
                  <label className="text-slate-600 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                    {t("Mobile Number")}
                  </label>
                  <div className="border border-slate-200 focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500 rounded-xl px-3.5 py-2 transition-all">
                    <PhoneInput
                      className="w-full"
                      international
                      defaultCountry="IN"
                      value={value}
                      onChange={setValue}
                      name="phone"
                    />
                  </div>
                </div>

                <div>
                  <label className="text-slate-600 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                    {t("Delivery Instructions (Optional)")}
                  </label>
                  <textarea
                    onChange={(e) =>
                      setAddressData({
                        ...addressData,
                        instruction: e.target.value,
                      })
                    }
                    className="w-full min-h-[70px] border border-slate-200 rounded-xl p-3 text-sm text-slate-700 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 resize-none transition-all"
                    placeholder={t(
                      "How to reach instruction (e.g. Ring bell, keep at security)...",
                    )}
                  />
                </div>

                <div>
                  <label className="text-slate-600 text-xs font-semibold uppercase tracking-wider block mb-1.5">
                    {t("Save Address As")}
                  </label>
                  <input
                    onChange={(e) =>
                      setAddressData({
                        ...addressData,
                        address_as: e.target.value,
                      })
                    }
                    className="w-full border border-slate-200 rounded-xl px-3.5 py-2.5 text-sm text-slate-700 outline-none focus:border-indigo-500 focus:ring-1 focus:ring-indigo-500 transition-all"
                    type="text"
                    placeholder={t("Eg: Home, Work, Friend's Place")}
                  />
                </div>
              </div>
            </div>

            <div className="pt-4 border-t border-slate-100 mt-4">
              <button
                onClick={HandleSaveAddress}
                className="w-full bg-slate-900 hover:bg-slate-800 text-white font-semibold py-3 rounded-xl shadow-md hover:shadow-lg active:scale-99 transition-all duration-150 text-sm md:text-base"
              >
                {t("Save Address")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Payment Modal */}
      {isPayment && (
        <div
          onClick={() => setIsPayment(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl shadow-2xl p-6 max-w-md w-full relative overflow-hidden"
          >
            <button
              onClick={() => setIsPayment(false)}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-all duration-200 z-20"
              aria-label="Close"
            >
              <IoClose className="w-6 h-6" />
            </button>

            <div className="mb-4 pr-8 border-b border-slate-100 pb-3">
              <h2 className="font-bold text-slate-800 text-lg md:text-xl">
                {t("Select Payment Method")}
              </h2>
            </div>

            <div className="mt-2">
              <Payment Amount={TotalAmt} Data={allData} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartBooking;
/* jshint ignore:end */
